import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { shouldUseDsoStructure } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';

interface IProps {
  children: ReactNode;
}

export const NotAllowedGuard = ({ children }: IProps) => {
  const navigate = useNavigate();
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);

  useEffect(() => {
    if (shouldUseDsoStructure() && !selectedOfficeId) {
      navigate('/', { state: { showNotAllowedPopup: true } });
    }
  }, [selectedOfficeId, navigate]);

  if (shouldUseDsoStructure() && !selectedOfficeId) {
    return <></>;
  }

  return <>{children}</>;
};
